import React from "react";
import { connect } from "react-redux";
import { Input } from "@revvsales/components";
import { RevvForm, ErrorMessages } from "../../../../commonComponents";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";

// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
  setFlagForCommonFields,
} = DocumentTemplateActions;

class PersonNameField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDefaultValue: this._getShowDefaultValue(props),
      personNameFieldValues: this._getDataForPrepopulate(props),
    };
  }

  _getShowDefaultValue = propsData => {
    let returnData = false;
    if (propsData.meta && propsData.meta.default) {
      returnData = true;
    }
    return returnData;
  };

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.PERSON_NAME),
    );
    if (
      propsData.meta &&
      propsData.meta.default &&
      Object.keys(propsData.meta.default).length > 0
    ) {
      returnData = propsData.meta !== undefined && propsData.meta.default;
    }
    return returnData;
  };

  _toggleDefaultValue = () => {
    const { showDefaultValue } = this.state;
    this.setState({ showDefaultValue: !showDefaultValue });
    this.props.setFlagForDefault(!showDefaultValue);
  };

  render() {
    const { showDefaultValue, personNameFieldValues } = this.state;
    return (
      <React.Fragment>
        <Input
          id="checkbox"
          type="checkbox"
          data-test="PersonNameField-checkbox"
          checked={showDefaultValue}
          onChange={() => this._toggleDefaultValue()}
          className="dynamicfieldcustom-footer-input errorborder"
        />
        <span className="dynamicfieldcustom-footer-checkboxinput">
          This has a default value
        </span>
        {showDefaultValue && (
          <RevvForm
            initialFormValue={personNameFieldValues}
            customFieldName="PERSON_NAME"
            validateOnChange
            customFieldComponentRules={CustomFieldComponentRules}
            customFieldComponentMessages={CustomFieldComponentMessages}
            render={formProps => {
              const {
                handleChange,
                handleBlur,
                messages,
                values,
                isValid,
              } = formProps;
              if (isValid) {
                const data = {
                  default: values,
                };
                this.props.metaValidStatus(true);
                this.props.setMetaFieldValues(data);
              } else {
                this.props.metaValidStatus(false);
                this.props.setMetaFieldValues({});
              }
              return (
                <React.Fragment>
                  <div className="dynamicfieldcustom-revvform">
                    <span className="revvform-label">
                      First name
                      <span className="requiredwitherr-input">*</span>
                    </span>
                    <Input
                      id="firstName"
                      name="firstName"
                      type="text"
                      data-test="PersonNameField-firstName"
                      placeholder="Enter first name here"
                      value={values && values.firstName}
                      className="dynamicfieldcustom-footer-input errorborder"
                      onChange={value => handleChange(value)}
                      onBlur={value => handleBlur(value)}
                      required
                    />
                    {messages.firstName && (
                      <ErrorMessages messages={messages.firstName.required} />
                    )}
                    <span className="revvform-label">Last name</span>
                    <span className="requiredwitherr-input">*</span>
                    <Input
                      id="lastName"
                      type="text"
                      data-test="PersonNameField-lastName"
                      name="lastName"
                      placeholder="Enter last name here"
                      value={values && values.lastName}
                      className="dynamicfieldcustom-footer-input errorborder"
                      onChange={value => handleChange(value)}
                      onBlur={value => handleBlur(value)}
                    />
                    {messages.lastName && (
                      <ErrorMessages messages={messages.lastName.required} />
                    )}
                  </div>
                </React.Fragment>
              );
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
  setFlagForCommonFields,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PersonNameField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/PersonNameField.js